export const TextInputNombreProps = {
    type: "text",
    maxLength: "70"
};

export const TextInputCorreoProps = {
    type: "email",
    maxLength: "50"
};

export const TextInputTelProps = {
    type: "text",
    maxLength: "10",
    pattern: "[0-9]{3}[0-9]{3}[0-9]{4}"
};

export const buttonEvents = {
    className: 'some-class'
};